import { colorBackgroundCollapseSelected } from "../../../utils/setting";
export const styles = (theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing(3),
  },
  table: {
    minWidth: 1020,
    borderTop: "solid 1px #dcdcdc",
  },
  tableWrapper: {
    overflowX: "auto",
  },
  editForm: {
    display: "none",
  },
  button: {
    width: "-webkit-fill-available",
    minWidth: "max-content",
  },
  alignCenter: {
    textAlign: "center",
  },
  infoBranch: {
    padding: "10px 24px",
  },
  selectedMenu: {
    "&:focus": {
      backgroundColor: "transparent",
    },
  },
  selectedRoot: {
    display: "flex",
    justifyContent: "left",
  },
  detailBrand: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  formControl: {
    //   margin: theme.spacing(1),
    minWidth: "100%",
  },

  btnStatus: {
    width: "6rem",
    minWidth: 80,
    fontSize: "0.675rem",
  },
  // modify
  TableRowHeight: {
    height: 0,
  },
  notificationsActiveIcon: {
    color: "#ff513f",
  },
  frameTitle: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  infoRecord: {
    fontSize: "0.8rem",
    color: "#546e7a",
    marginTop: "1.6rem",
  },
  containerFilter: {
    marginLeft: "1rem",
    [theme.breakpoints.down("sm")]: {
      marginLeft: "0.5rem",
    },
  },
  list: {
    width: "20rem",
    padding: "1.5rem",
  },
  collapseSelected: {
    backgroundColor: colorBackgroundCollapseSelected,
  },
  textField: {
    minWidth: "10rem",
  },
  bookingcheking: {
    color: "#fb8c00",
  },
  tableCellInCollapes: {
    borderBottom: "none",
  },
});

export const editStyles = (theme) => ({
  container: {
    display: "flex",
    justifyContent: "center",
    flexWrap: "wrap",
    padding: theme.spacing(3),
    borderBottom: "1px solid rgba(224, 224, 224, 1)",
  },
  textField: {
    width: "100%",
  },
  containerButton: {
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-end",
  },
  input: {},
  label: {
    fontWeight: 410,
  },
  chip: {
    margin: theme.spacing(1),
  },
  dense: {
    marginTop: 16,
  },
  labelTextField: {
    backgroundColor: "#fff",
  },
  button: {
    margin: theme.spacing(1),
    width: "100%",
  },
  formControl: {
    margin: theme.spacing(1),
  },
  status: {
    textTransform: "capitalize",
  },
  badge: {
    top: 1,
    // left: -theme.spacing(2),
    width: "1.6rem",
    height: "1.6rem",
    borderRadius: "50%",
    // The border color match the background color.
    border: `2px solid ${
      theme.palette.type === "light"
        ? theme.palette.grey[200]
        : theme.palette.grey[900]
    }`,
  },
  avatar: {
    marginRight: theme.spacing(1),
  },
  chipItem: {
    display: "flex",
  },
  textItem: {
    margin: "0px 4px",
  },
});
